import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios'
interface IHeader {
    key: string
    value: string
}

export interface HttpRequestError<T = any> extends Error {
    status: number
    statusText: string
    data: T
}

class HttpRequest {
    axiosInstance: AxiosInstance
    constructor(url: string) {
        this.axiosInstance = axios.create({
            baseURL: url,
            timeout: 120000,
        })
        this.axiosInstance.defaults.headers['Content-Type'] = 'application/json'

        this.axiosInstance.interceptors.request.use(
            (config) => {
                // Do something before request is sent
                return config
            },
            (error: AxiosError) => {
                // Do something with request error
                return Promise.reject(error)
            },
        )

        // Add a response interceptor
        this.axiosInstance.interceptors.response.use(
            (response) => {
                // Do something with response data
                return response
            },
            (error: AxiosError) => {
                // Do something with request error
                return Promise.reject<HttpRequestError>({
                    status: error.response?.status,
                    statusText: error.response?.statusText,
                    data: error.response?.data,
                })
            },
        )
    }

    setHeader(header: IHeader) {
        this.axiosInstance.defaults.headers.common[header.key] = header.value
    }

    get<type = any>(methodName: string, config?: AxiosRequestConfig) {
        return this.axiosInstance.get<type>(methodName, config)
    }

    post<type = any>(
        methodName: string,
        data?: any,
        config?: AxiosRequestConfig,
    ) {
        return this.axiosInstance.post<type>(methodName, data, config)
    }

    put<type = any>(
        methodName: string,
        data?: any,
        config?: AxiosRequestConfig,
    ) {
        return this.axiosInstance.put<type>(methodName, data, config)
    }

    delete<type = any>(methodName: string, config?: AxiosRequestConfig) {
        return this.axiosInstance.delete<type>(methodName, config)
    }
}

export default HttpRequest
